// PaymentMethodApi.js

import apiServices from "../common/apiServices";

 // Define the tag types related to entication
export const addTagTypes = [ 'Payment'];

// Enhance the base API service by adding entication-related tag types
const PaymentMethodApi = apiServices
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
    
     
      // Fetch Payment query (GET request to /me)
      getPayment: build.query({
        query: () => ({
          url: `/payments`,
        }),
        providesTags: ['Payment'],
      }),   
    }),
    overrideExisting: false,
  });

export default PaymentMethodApi;

// Exporting hooks for each endpoint to be used in components
export const {
   useGetPaymentQuery
} = PaymentMethodApi;


